import { preview } from '@/components/form/preview'
import { ConvertTime } from '@/components/smartUtils/conversion/ConvertTime'

import { useTexts } from '../useTexts'
import { NumberedLabel } from './NumberedLabel'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function CheckIn(props: Props) {
  const { extOrder } = props
  const texts = useTexts()

  const timeInSec = extOrder.orderStep.trackingData?.timeInSec ?? -1
  const timeInDisabled = timeInSec === -1

  return (
    <preview.Field
      label={
        <NumberedLabel
          number={1}
          label={texts.checkIn.label}
          color="#FF9800"
          disabled={timeInDisabled}
        />
      }
      testId="execution-reported-check-in"
    >
      {timeInSec > 0 ? (
        <ConvertTime seconds={timeInSec} showSeconds={false} />
      ) : (
        <preview.NullValue />
      )}
    </preview.Field>
  )
}
